import React from "react";

const IconEdit = ({ color = "#e31c19" }) => {
  return (
    <svg
      id="UI_icon_note_light"
      data-name="UI icon/note/light"
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16.667"
      viewBox="0 0 15 16.667"
    >
      <path
        id="Rectangle_193_Stroke_"
        data-name="Rectangle 193 (Stroke)"
        d="M2.5,1.667a.833.833,0,0,0-.833.833V14.167A.833.833,0,0,0,2.5,15h10a.833.833,0,0,0,.833-.833V8.333a.833.833,0,0,1,1.667,0v5.833a2.5,2.5,0,0,1-2.5,2.5H2.5a2.5,2.5,0,0,1-2.5-2.5V2.5A2.5,2.5,0,0,1,2.5,0h5a.833.833,0,0,1,0,1.667Z"
        fill={color}
      />
      <path
        id="Union"
        d="M.831,11.19h0a.834.834,0,0,1-.823-.951L.4,7.489a.838.838,0,0,1,.236-.471L6.923.732a2.5,2.5,0,1,1,3.535,3.535L4.173,10.553a.839.839,0,0,1-.472.235l-2.75.393A.852.852,0,0,1,.831,11.19Zm5.5-7.512h0L2.012,8l-.2,1.375,1.375-.2L7.512,4.857,6.333,3.679ZM8.69,1.667a.828.828,0,0,0-.589.244L7.512,2.5,8.69,3.679l.59-.589a.833.833,0,0,0-.59-1.422Z"
        transform="translate(3.583 1.036)"
        fill={color}
      />
    </svg>
  );
};

export default IconEdit;
